import { IconCheckDefault } from '@iwoca/icons';
import { clsx } from 'clsx';

import styles from './ProgressBar.module.css';

const STEPS = [
  { label: 'Application', status: 'completed' },
  { label: 'Supporting documents', status: 'active' },
  { label: 'Decision', status: 'upcoming' },
] as const;

type StepStatus = (typeof STEPS)[number]['status'];

const barStyleMap: Record<StepStatus, string> = {
  completed: styles.barCompleted,
  active: styles.barActive,
  upcoming: styles.barUpcoming,
};

export const ProgressBar = () => {
  return (
    <div className={styles.container}>
      {STEPS.map((step) => (
        <div key={step.label} className={styles.step}>
          <div className={clsx(styles.bar, barStyleMap[step.status])} />
          <span
            className={clsx(styles.label, {
              [styles.labelActive]: step.status === 'active',
              [styles.labelUpcoming]: step.status === 'upcoming',
              [styles.labelCompleted]: step.status === 'completed',
            })}
          >
            {step.status === 'completed' && (
              <IconCheckDefault
                className={styles.checkmark}
                data-testid="checkmark-icon"
              />
            )}
            {step.label}
          </span>
        </div>
      ))}
    </div>
  );
};
